module.exports = __webpack_public_path__ + "static/img/vip.eb5bba89.png";